import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useShopping } from '../hooks/useShopping';
import ShoppingList from '../components/shopping/ShoppingList';
import AddItemForm from '../components/shopping/AddItemForm';
import CategoryFilter from '../components/shopping/CategoryFilter';

export default function ShoppingPage() {
  const { t } = useTranslation();
  const { items, categories, loading, error, addItem, toggleItem, deleteItem, addCategory } = useShopping();
  const [filter, setFilter] = useState<string | null>(null);
  const [showAddForm, setShowAddForm] = useState(false);

  if (loading) return <div className="flex items-center justify-center h-64">{t('app.loading')}</div>;
  if (error) return <div className="px-4 py-6 text-red-600">{error}</div>;

  const activeItems = items.filter(i => i.status === 'active' && (!filter || i.category === filter));
  const boughtItems = items.filter(i => i.status === 'bought' && (!filter || i.category === filter));

  return (
    <div className="max-w-2xl mx-auto pb-24">
      {/* Header */}
      <div className="sticky top-14 z-40 bg-gray-50 px-4 pt-4 pb-2">
        <div className="flex items-center justify-between mb-3">
          <h1 className="text-xl font-bold text-gray-800">🛒 {t('shopping.title')}</h1>
          <button
            onClick={() => setShowAddForm(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded-xl text-sm font-medium hover:bg-blue-700 active:scale-95 transition"
          >
            + {t('shopping.addItem')}
          </button>
        </div>

        <CategoryFilter
          categories={categories}
          filter={filter}
          onFilterChange={setFilter}
          onAddCategory={addCategory}
        />
      </div>

      {/* Items */}
      <div className="px-4">
        <ShoppingList
          activeItems={activeItems}
          boughtItems={boughtItems}
          onToggle={toggleItem}
          onDelete={deleteItem}
        />
      </div>

      {/* Add Item Modal */}
      {showAddForm && (
        <AddItemForm
          categories={categories}
          onAdd={async (name, category) => {
            await addItem(name, category);
            setShowAddForm(false);
          }}
          onClose={() => setShowAddForm(false)}
        />
      )}
    </div>
  );
}
